import BaseListFilter, {
  type BaseListFilterType,
} from "@search/store/filters/base/BaseListFilter";

class NumberListFilter extends BaseListFilter {
  constructor({
    name = "numberList",
    label = name,
    value,
  }: BaseListFilterType) {
    super({ label, name, value: value as Array<number> });
  }

  get defaultValue() {
    return super.defaultValue as Array<number>;
  }

  get initialValue() {
    return super.initialValue as Array<number>;
  }

  get value() {
    return super.value as Array<number>;
  }
}

export default NumberListFilter;
export { NumberListFilter };
